import { createContext } from 'react';
import { RoomTypeGrp } from 'ts/hotel/classes/FilterModel';

export const HotelDetailsContext = createContext({
  roomTypes: [] as RoomTypeGrp[],
  setRoomTypes: (_roomTypes: RoomTypeGrp[]) => {},
});
